import i18n from 'javascript/i18n'

export function onlyEnJp(value, isJA) {
  let error = null
  if (!value) {
    return error
  }
  const jpPattern = new RegExp(
    /[\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f]/g
  )
  const enPattern = new RegExp(/^[a-zA-Z0-9 ]+$/g)
  const locale = i18n.locale
  if ((locale === 'ja' && jpPattern.test(value)) || (locale !== 'ja' && enPattern.test(value))) {
    error = null
  } else {
    const fullNameError = i18n.t('contact_form.error.full_name_error')
    error = isJA
      ? i18n.t('contact_form.error.full_name_error_for_car') || fullNameError
      : fullNameError
  }
  return error
}

export function validateTelFormat(value) {
  let error = null
  if (!value) {
    return error
  }
  const telPattern = /^[0-9０１２３４５６７８９ (+)-]+$/i
  if (!telPattern.test(value)) {
    error = i18n.t('contact_form.error.tel_format_error')
  }
  return error
}

export function validateEmailFormat(email) {
  let error = null
  if (!email) {
    return error
  }
  const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+(\.[A-Z]{2,})$/i
  if (!emailPattern.test(email)) {
    error = i18n.t('contact_form.error.email_format_error')
  }
  return error
}

export function validateEmailConfirmation(email, emailConfirmation) {
  let error = null
  if (!email && !emailConfirmation) {
    return error
  }
  if (email !== emailConfirmation) {
    error = i18n.t('contact_form.error.email_confirmation_error')
  }
  return error
}
